import styles from "../styles/ui/ContentCard.module.css";

function ContentCard({ className = "", style = {}, children, id = "" }) {
  return (
    <div className={`${styles.container} ${className}`} style={style} id={id}>
      {children}
    </div>
  );
}

export default ContentCard;
